import React from "react";
import { Link } from "react-router-dom";
import { getQuizPath } from "./quizData";

const QuizCard = ({ quiz, onOpen }) => (
  <article className="quiz-card">
    <div className="quiz-card-header">
      <span className="category-tag">{quiz.category}</span>
      {quiz.difficulty && (
        <span className="quiz-difficulty">{quiz.difficulty}</span>
      )}
    </div>
    <h3>{quiz.title}</h3>
    <p>{quiz.description}</p>
    <div className="quiz-card-meta">
      <span>{quiz.questionCount} questions</span>
      <span>{quiz.estimatedTime}</span>
    </div>
    <Link
      to={getQuizPath(quiz)}
      className="primary-btn quiz-card-cta"
      onClick={onOpen}
    >
      Start Quiz
    </Link>
  </article>
);

export default QuizCard;
